// extracted by mini-css-extract-plugin
export default {"pickerArea":"DateSwitch_pickerArea__S0Pm1","label":"DateSwitch_label__Xufz1"};